export default __webpack_public_path__ + "static/media/join-us-starting.a99d571e.png";